import { render } from "./AFooterBottom.vue?vue&type=template&id=6ed21916"
import script from "./AFooterBottom.vue?vue&type=script&lang=ts"
export * from "./AFooterBottom.vue?vue&type=script&lang=ts"

import "./AFooterBottom.vue?vue&type=style&index=0&id=6ed21916&lang=postcss"
script.render = render

export default script